module.exports = __webpack_public_path__ + "static/img/carousel_2_klrq02_ar_4_3_w_1086.9fdc2f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_2_klrq02_ar_4_3_w_1086.jpg
// module id = WR6K
// module chunks = 0